import { render, staticRenderFns } from "./QuestionLevelPicker.vue?vue&type=template&id=ba96795e"
import script from "./QuestionLevelPicker.vue?vue&type=script&lang=js"
export * from "./QuestionLevelPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports